export enum AccountValidationAction {
    AddMoney,
    WithdrawMoney,
}
